module.exports = __webpack_public_path__ + "img/submit-group-quote.7c299d02.png";